import React from 'react';
import { Table, Button, Popup } from 'semantic-ui-react';

const getLeaseholderName = (el) => {
    if (el.entityType.id === 1) {
        return (el.physicalEntity.firstName + ' ' + el.physicalEntity.lastName);
    } else if (el.entityType.id === 2) {
        return el.legalEntity.name;
    }
    return el.organizationalUnitLeaseholder.name;
};

const LeasesTable = ({
    leases, activateEditRequest, writePrivilege, switchToDetails, getSortedLeases, fieldName, direction
}) => (
    <Table celled selectable sortable>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>Organizaciona jedinica</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'organizationalUnitProperty' ? direction : null}
                    onClick={() => getSortedLeases('organizationalUnitProperty', 'id')}
                >Imovina</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'leaseholder' ? direction : null}
                    onClick={() => getSortedLeases('leaseholder', 'id')}
                >Zakupac</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'dateStart' ? direction : null}
                    onClick={() => getSortedLeases('dateStart')}
                >Početak zakupa</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'dateEnd' ? direction : null}
                    onClick={() => getSortedLeases('dateEnd')}
                >Istek zakupa</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'incomePerMonth' ? direction : null}
                    onClick={() => getSortedLeases('incomePerMonth')}
                >Mjesečni prihodi (BAM)</Table.HeaderCell>



                {writePrivilege &&
                <Table.HeaderCell></Table.HeaderCell>
                }
            </Table.Row>
        </Table.Header>

        <Table.Body>
            {leases.map(el =>
                (
                    <Table.Row key={el.id}>

                        <Table.Cell onClick={() => switchToDetails(el)}>{!!el.organizationalUnitProperty && el.organizationalUnitProperty.organizationalUnit.name}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{!!el.organizationalUnitProperty && el.organizationalUnitProperty.property.name}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{getLeaseholderName(el.leaseholder)}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{!!el.beginDate && el.beginDate.getUTCDate() + 1}. {!!el.beginDate && el.beginDate.getUTCMonth() + 1}. {!!el.beginDate && el.beginDate.getUTCFullYear()}.</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{!!el.endDate && el.endDate.getUTCDate()}. {!!el.endDate && el.endDate.getUTCMonth() + 1}. {!!el.endDate && el.endDate.getUTCFullYear()}.</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{el.incomePerMonth}</Table.Cell>

                        {writePrivilege &&
                        <Table.Cell verticalAlign="middle" className="text-center" >
                            <Popup
                                content="Izmjena"
                                position="top center"
                                trigger={

                                    <Button
                                        basic="true"
                                        circular
                                        icon="pencil"
                                        size="tiny"
                                        color="green"
                                        onClick={() => activateEditRequest(el)}
                                    />

                                }
                            />
                            <Popup
                                content="Brisanje"
                                position="top center"
                                trigger={

                                    <Button
                                        basic="true"
                                        circular
                                        disabled
                                        icon="close"
                                        size="tiny"
                                        color="red"
                                        onClick={() => {

                                        }}
                                    />

                                }
                            />
                        </Table.Cell>
                        }
                    </Table.Row>
                ))
            }
        </Table.Body>
    </Table>);

export default LeasesTable;



// WEBPACK FOOTER //
// ./src/views/Assets/Leases/LeasesTable.js